import Model from 'flarum/common/Model';
import mixin from 'flarum/common/utils/mixin';

export default class SupportTicket extends mixin(Model, {
  discussion: Model.hasOne('discussion'),
  privateNote: Model.attribute('privateNote'),
  answer: Model.hasOne('answer'),
  answeredAt: Model.attribute('answeredAt'),
  ticketStatus: Model.attribute('ticketStatus'),
  ticketPriority: Model.attribute('ticketPriority'),
  assignees: Model.hasMany('assignees'),
  language: Model.hasOne('language'),
  remindedCount: Model.attribute('remindedCount'),
  canConvertIntoDiscussion: Model.attribute('canConvertIntoDiscussion'),
}) {
  apiEndpoint() {
    return '/support/ticket' + (this.exists ? '/' + this.data.id : '');
  }
}
